module.exports = __webpack_public_path__ + "assets/img/ad21876ee7bc210f97660094113484a4.png";